module.exports = __webpack_public_path__ + "media/images/flags/4x3/cok-4b0176c03f6d159add5d5fc1b7db5773.svg";